import React from 'react'
import { TextLink } from 'baby-design'
import { BuyItOrMarkAsPurchasedProps } from './BuyItOrMarkAsPurchased.types'
import css from './BuyItOrMarkAsPurchased.styles.scss'

const BuyItOrMarkAsPurchased: React.FC<BuyItOrMarkAsPurchasedProps> = () => (
  <div
    className={css.BuyItOrMarkAsPurchased}
    data-testid="BuyItOrMarkAsPurchased"
  >
    <TextLink underline size="md">
      Buy it or mark as purchased
    </TextLink>
  </div>
)

export default BuyItOrMarkAsPurchased
